import { Space, Spin } from "antd";
import React, { useContext, useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import FetchContext from "../../contexts/fetch";
import SimulationContext from "../../contexts/simulation";
import UserContext from "../../contexts/user";
import BackCurtain from "../BackCurtain";
import AlloBrain from "./AlloBrain";
import CallBot from "./CallBot";
import styles from "./simulation.module.css";
import WebApp from "./WebApp";

const Simulation = () => {
  // context avec type: call-bot, web-app, allo-brain
  const [simulationState, simulationDispatcher] = useContext(SimulationContext);

  const [userState] = useContext(UserContext);

  const [, fetchDispatcher] = useContext(FetchContext);

  const [loading, setLoading] = useState(false);

  const handleCloseButtonClick = function () {
    simulationDispatcher({
      type: "toggle",
      app: userState.currentApp,
      config: simulationState.active ? null : simulationState.config,
    });
  };

  const fetchApi = function (api_endpoint = null, parameters = {}, body = {}) {
    fetchDispatcher({
      type: "fetch-simulate-flow",
      app: userState.currentApp,
      queryParameters: {
        ...parameters,
        app: userState.currentApp,
        brand: userState.currentBrand,
      },
      api_endpoint,
      body,
    });
  };

  return (
    simulationState.active && (
      <div>
        <BackCurtain />

        {loading && (
          <div className={styles.loader}>
            <Space size="middle">
              <Spin size="large" />
            </Space>
          </div>
        )}

        <div className={styles.simulation_container}>
          <div className={styles.close_button_container}>
            <AiOutlineCloseCircle
              className={styles.close_button}
              onClick={handleCloseButtonClick}
            />
          </div>
          <div className={styles.content_container}>
            {userState.currentApp === "call-bot" ? (
              <CallBot fetchApi={fetchApi} setLoading={setLoading} />
            ) : userState.currentApp === "allo-brain" ? (
              <AlloBrain fetchStoreId={fetchApi} setLoading={setLoading} />
            ) : userState.currentApp === "web-app" ? (
              <WebApp
                configID={simulationState.config.name}
                setLoading={setLoading}
              />
            ) : (
              <div>
                <p>Aucune application sélectionnée</p>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default Simulation;
